import React, { useMemo } from "react";
import objectPath from "object-path";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";
// Import Layout components
import ReactZenDeskChat from "@inlightmedia/react-zendesk-chat";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Aside } from "./aside/Aside";
import { Footer } from "./footer/Footer";
import { SubHeader } from "./subheader/SubHeader";
import { LayoutInit } from "./LayoutInit";
import { useLocation } from "react-router-dom";
import { useSubheader } from "../_core/MetronicSubheader";

export function Layout({ children }) {
  const { pathname } = useLocation();
  const uiService = useHtmlClassService();
  const subheader = useSubheader();
  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      desktopHeaderDisplay: objectPath.get(
        uiService.config,
        "header.self.fixed.desktop"
      ),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended"),
    };
  }, [uiService]);

  return layoutProps.selfLayout !== "blank" ? (
    <>
      {/*begin::Main*/}
      <HeaderMobile />
      <div className="d-flex flex-column flex-root">
        {/*begin::Page*/}
        <div className="d-flex flex-row flex-column-fluid page">
          {layoutProps.asideDisplay && <Aside />}
          {/*begin::Wrapper*/}
          <div
            className="d-flex flex-column flex-row-fluid wrapper"
            id="kt_wrapper"
          >
            {/*begin::Content*/}
            <div
              id="kt_content"
              className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
              style={{
                backgroundColor: pathname.includes("/dashboard") && "#040719",
              }}
            >
              {layoutProps.subheaderDisplay && <SubHeader />}
              {/*begin::Entry*/}
              {!layoutProps.contentExtended && (
                <div className="d-flex flex-column-fluid">
                  {/*begin::Container*/}
                  <div className={layoutProps.contentContainerClasses}>
                    <div
                      style={{ paddingBottom: "0" }}
                      className="table-container"
                    >
                      {/* Same hardcoded fallback as the subheader carried, with
                          the same effect: a page whose title hadn't resolved
                          yet announced itself as "Share Resources". Resolution
                          moved into the menu-config lookup. */}
                      <h1 style={{ fontWeight: "bold" }}>{subheader.title}</h1>
                    </div>

                    {children}
                  </div>
                  {/*end::Container*/}
                </div>
              )}

              {layoutProps.contentExtended && { children }}
              {/*end::Entry*/}
            </div>
            {/*end::Content*/}
            <Footer />
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Page*/}
      </div>
      {/* <QuickUser/>
            <QuickPanel/>
            <ScrollTop/> */}
      {/*end::Main*/}
      <LayoutInit /> {/* Required to mobile view */}
      <ReactZenDeskChat appID={process.env.REACT_APP_ZENDESK_KEY} />
    </>
  ) : (
    // BLANK LAYOUT
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}
